// @cloudnest/cascadia-engine — data barrel.

export type { ArtKind, ArtRef } from "./art-keys";
export { resolveArtKey } from "./art-keys";
export type { BagComposition } from "./bag-supply";
export {
  BASE_BAG,
  LANDMARK_TRIGGER_CORRIDOR_SIZE,
  LANDMARKS_DELTA,
  MARKET_SLOT_COUNT,
  MAX_LANDMARKS_PER_PLAYER,
  SOLO_HABITAT_BONUS_POINTS,
  SOLO_HABITAT_BONUS_THRESHOLD,
  STARTER_CLUSTER_COUNT,
  tilesPerPlayerCount,
} from "./bag-supply";
export { resolveTileDefId, resolveWildlifeSpecies } from "./instance-resolver";
export {
  LANDMARK_CARDS,
  LANDMARK_CARDS_BY_HABITAT,
  LANDMARK_CARDS_BY_ID,
} from "./landmark-cards";
export type { StartCluster, StartClusterTile } from "./start-tiles";
export { START_CLUSTERS, START_CLUSTERS_BY_ID } from "./start-tiles";
export { TILE_DEFS, TILE_DEFS_BY_ID } from "./tile-defs";
export {
  WILDLIFE_SCORING_CARDS,
  WILDLIFE_SCORING_CARDS_BY_ID,
} from "./wildlife-scoring-cards";
